import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "timetable" }
const _hoisted_2 = {
  key: 0,
  class: "timetable__header"
}
const _hoisted_3 = { class: "timetable__title" }
const _hoisted_4 = {
  key: 2,
  class: "timetable__warning"
}

import SvgIcon from "@/components/icons/SvgIcon.vue";
import { YYYYMMDD } from "@/helpers/dateHelpers";
import { startOfToday, format } from "date-fns";
import { VBtn } from "v-ferry-components";
import { computed, ref, watch } from "vue";
import { getQueryParamValue } from "@/helpers/urlHelper";
import useTimetableQuery from "../composables/useTimetableQuery";
import TimetableDates from "./TimetableDates.vue";
import TimetableTable from "./TimetableTable.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Timetable',
  setup(__props) {

const activeRoute = ref<string>();

const routeCode = (document.getElementById("timetable-container")?.getAttribute("data-route") as string) ?? getQueryParamValue("route");

const { data: departures, isFetching } = useTimetableQuery(routeCode);

const selectedDate = ref<string>(format(startOfToday(), 'yyyy-MM-dd'));

const filteredDepartures = computed(() => departures.value?.filter((departure) => 
    YYYYMMDD(departure.departureDateTime) === selectedDate.value &&
    departure.routeCode == activeRoute.value
));

function printTimetable() {
    window.print();
}

const setSelectedDate = (date: Date) => {
    selectedDate.value = format(date, 'yyyy-MM-dd');
};

// Switches the first 3 and last 3 letters of the activeRoute
function toggleActiveRoute() {
    if (activeRoute.value) {
        const half = Math.floor(activeRoute.value.length / 2);
        activeRoute.value = activeRoute.value.slice(half) + activeRoute.value.slice(0, half);
    }
}

// Make sure that activeRoute is set when there's a routeCode
watch(() => routeCode, (value) => 
    { activeRoute.value = value },
    { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (activeRoute.value?.length && filteredDepartures.value?.length)
      ? (_openBlock(), _createElementBlock("header", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", null, _toDisplayString(filteredDepartures.value[0].routeName), 1),
            _createVNode(_unref(VBtn), {
              onClick: toggleActiveRoute,
              color: "accent",
              class: "v-btn--circle"
            }, {
              default: _withCtx(() => [
                _createVNode(SvgIcon, {
                  icon: "carbon/arrows-horizontal",
                  width: "1.5rem",
                  height: "1.5rem"
                })
              ]),
              _: 1
            })
          ]),
          _createVNode(_unref(VBtn), {
            color: "secondary",
            onClick: printTimetable
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t(`timetable.download`)), 1),
              _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fa fa-download" }, null, -1))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(TimetableDates, { onSelectedDate: setSelectedDate }),
    (_unref(routeCode))
      ? (_openBlock(), _createBlock(TimetableTable, {
          key: 1,
          departures: filteredDepartures.value,
          isLoading: _unref(isFetching)
        }, null, 8, ["departures", "isLoading"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t(`timetable.warnings.routes`)), 1)
        ]))
  ]))
}
}

})